<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from "./components/popup";
import { mapState } from "vuex";
import { vConsoleWidget } from "@/utils/index";
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(["loading"])
  },
  watch: {
    $route(route, oldVal) {
      if (route) this.loadvConsoleWidget(route);
    }
  },
  created() {},
  mounted() {
    this.loadvConsoleWidget(this.$route);
    if (this.browser === "wechat") this.wechatSetDefaultLanguage();
  },

  methods: {
    /**
     * 加载vConsole小部件
     */
    loadvConsoleWidget(route = {}) {
      const { vc } = route.query;
      if (vc === "true") vConsoleWidget();

      vConsoleWidget(); // todo
    },
    /**
     * 设置微信默认语言
     */
    wechatSetDefaultLanguage() {
      const _lang = localStorage.getItem("cdb_lang");
      if (!_lang) {
        let tempVal = this.localeArr[0];
        this.$i18n.locale = tempVal.value;
        this.$store.commit("lang", tempVal.value);
      }
    }
  }
};
</script>

<style lang="less">
@import "./assets/css/public.less";
body {
  background: #fff;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #333333;
}
#app {
  font-size: 28px;
}
.btn {
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #e4e82b;
  font-size: 32px;
  border-radius: 24px;
}
</style>
